
/* MAKEUPMX - SCROLL INDICATOR */

(() => {
  if (window.mxScrollInstalled) return;
  window.mxScrollInstalled = true;

  const arrow = document.createElement('div');
  arrow.className = 'mx-scroll-indicator';



arrow.innerHTML = `
  <svg
    viewBox="0 0 20 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M5 5 L10 10 L15 5" />
    <path d="M5 14 L10 19 L15 14" />
  </svg>
`;


  document.body.appendChild(arrow);

  function update() {
    const nav = document.querySelector(
      'header.header .nav--mobile'
    );

    const panel = nav?.querySelector(
      '.nav__secondary-menu:has(.nav__secondary-menu__item--visible)'
    );

    if (!nav || !panel ||
        window.innerWidth > 767) {
      arrow.style.display = 'none';
      return;
    }

    const elements = [
      nav,
      ...nav.querySelectorAll('*')
    ];

    const scroller = elements.find(el => {
      const style = getComputedStyle(el);
      return (
        ['auto', 'scroll'].includes(style.overflowY) &&
        el.scrollHeight > el.clientHeight + 5 &&
        el.contains(panel)
      );
    });

    if (!scroller) {
      arrow.style.display = 'none';
      return;
    }

    const remaining =
      scroller.scrollHeight -
      scroller.clientHeight -
      scroller.scrollTop;

    const box = nav.querySelector(':scope > .container') || nav;
    const rect = box.getBoundingClientRect();

   
arrow.style.display =
  rect.width > 0 ? 'block' : 'none';

const atBottom = remaining <= 8;

arrow.innerHTML = atBottom
  ? `
    <svg viewBox="0 0 20 24" fill="none"
      stroke="currentColor" stroke-width="1.8"
      stroke-linecap="round" stroke-linejoin="round">
      <path d="M5 10 L10 5 L15 10" />
      <path d="M5 19 L10 14 L15 19" />
    </svg>
  `
  : `
    <svg viewBox="0 0 20 24" fill="none"
      stroke="currentColor" stroke-width="1.8"
      stroke-linecap="round" stroke-linejoin="round">
      <path d="M5 5 L10 10 L15 5" />
      <path d="M5 14 L10 19 L15 14" />
    </svg>
  `;


    arrow.style.left =
      `${rect.right - 25 - 18}px`;

    arrow.style.top =
      `${rect.bottom - 25 - 24}px`;
  }

  document.addEventListener('scroll', update, true);
  window.addEventListener('resize', update);

  const observer = new MutationObserver(update);

  const nav = document.querySelector(
    'header.header .nav--mobile'
  );

  if (nav) {
    observer.observe(nav, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'aria-hidden']
    });
  }

  update();
})();
